import "./GalleryImage.scss";

interface IGalleryImage {
  image: string;
  alt: string;
  openModal: (item: string) => void;
}

const GalleryImage = ({ image, alt, openModal }: IGalleryImage) => {
  return (
    <div className="mainGalleryImageWrapper" onClick={() => openModal(image)}>
      <img src={image} alt={alt} loading="lazy" className="mainGalleryImage" />
    </div>
  );
};

export default GalleryImage;
